import React, { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import ViewBarcodeTable from './ViewBarcodeTable';

import {
  allBarcodeRequest,
  deleteBarcodeRequest,
  getBarcodeRequest,
} from '../../actions';

/** Match `AllJobsPage`: sidebar offset + full remaining viewport width for the table. */
const useStyles = makeStyles((theme) => ({
  introBox: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '130px',
    marginTop: '60px',
    fontFamily: 'Roboto Mono, monospace',
  },
  primaryText: { fontSize: '35px', fontWeight: 'bold' },
  secondaryText: { position: 'relative', top: '-10px', opacity: '.78' },
  tableWrap: {
    marginLeft: '130px',
    marginTop: theme.spacing(2),
    width: 'calc(100vw - 100px - 130px - 16px)',
    maxWidth: 'none',
    boxSizing: 'border-box',
    overflowX: 'auto',
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(4),
  },
}));

const ViewBarcode = ({ match }) => {
  const classes = useStyles();
  const history = useHistory();

  const [isChanged, updateIsChanged] = useState(true);
  const dispatch = useDispatch();
  const { allBarcodes } = useSelector((state) => state.Barcode);

  const loading = useSelector((state) => state.Loader);

  const barcodeIds = allBarcodes.map(({ id }) => id).join(',');

  const onDeleteBarcode = useCallback((selectedEmpCode) => {
    updateIsChanged(true);
    dispatch(deleteBarcodeRequest(selectedEmpCode));
  });
  

  useEffect(() => {
    if (!isChanged) {
      dispatch(allBarcodeRequest());
    }
    updateIsChanged(false);
  }, [dispatch, isChanged]);

  const data = React.useMemo(() => {
    return allBarcodes;
  }, [allBarcodes]);

  const onEditBarcodeClick = useCallback((empCode) => {
    updateIsChanged(true);
    dispatch(getBarcodeRequest(empCode));
    history.push(`${match.path}/edit/${empCode}`);
  });


  return (
    <>
      <Box className={classes.introBox}>
        <Typography variant='h3' component='h1' className={classes.primaryText}>
          All barcodes
        </Typography>
        <Typography variant='h6' component='span' className={classes.secondaryText}>
          Search and manage barcode labels linked to your jobs.
        </Typography>
      </Box>
      <Box className={classes.tableWrap}>
        <ViewBarcodeTable
          data={data}
          onDeleteBarcode={(gcnNo) => onDeleteBarcode(gcnNo)}
          match={match}
          onEditBarcodeClick={onEditBarcodeClick}
          isLoading={loading}
        />
      </Box>
    </>
  );
};

export default ViewBarcode;
